import { Group, Stack, Text } from '@mantine/core';
import { IconCalendarDue, IconCircleCheck } from '@tabler/icons-react';
import dayjs from 'dayjs';
import type { Milestone } from '../../types/milestones';

const DATE_FORMAT = 'MM/DD/YYYY';

function formatMilestoneDate(value: string | undefined): string | null {
  if (!value?.trim()) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(DATE_FORMAT) : null;
}

export function MilestoneDateLabels({ milestone }: { milestone: Milestone }) {
  const dueDateLabel = formatMilestoneDate(milestone.due_date);
  const completedDateLabel =
    milestone.status === 'completed' ? formatMilestoneDate(milestone.completed_date) : null;

  return (
    <Stack spacing={4}>
      {dueDateLabel ? (
        <Group spacing={6} noWrap aria-label={`Due ${dueDateLabel}`}>
          <IconCalendarDue
            size={16}
            style={{ color: 'var(--mantine-color-dimmed)' }}
            aria-hidden
          />
          <Text size="xs" color="dimmed" weight={600}>
            {dueDateLabel}
          </Text>
        </Group>
      ) : null}
      {completedDateLabel ? (
        <Group spacing={6} noWrap aria-label={`Completed ${completedDateLabel}`}>
          <IconCircleCheck
            size={16}
            style={{ color: 'var(--mantine-color-dimmed)' }}
            aria-hidden
          />
          <Text size="xs" color="dimmed" weight={600}>
            {completedDateLabel}
          </Text>
        </Group>
      ) : null}
    </Stack>
  );
}
